export default __webpack_public_path__ + "static/media/logo-full.b4e72c53.png";